import './Nav.css';
import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ThemeToggle from '../theme/ThemeToggle';
import { useTheme } from '../../theme/useTheme';

const LOGO_SRC = `${process.env.PUBLIC_URL}/Logo.png`;

const NAV_ITEMS = [
  { id: 'about', label: 'About Me', to: '/about' },
  { id: 'work', label: 'Work & Life', to: '/work' },
  { id: 'blog', label: 'Blog', to: '/blog' },
  { id: 'contact', label: 'Say Hi', to: '/contact' },
];

const MOBILE_NAV_ITEMS = [
  { id: 'home', label: 'Home', to: '/' },
  ...NAV_ITEMS,
];

const Nav = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);
  const isHome = pathname === '/';
  const isPathActive = (to) => {
    if (to === '/') return pathname === '/';
    return pathname.startsWith(to);
  };

  return (
    <div className={`nav${menuOpen ? ' is-open' : ''}`}>
      <div className="container nav__bar">
        <Link
          to="/"
          className={`nav__logo-home${!isHome && !menuOpen ? ' nav__logo-home--return' : ''}`}
          onClick={closeMenu}
          aria-label="Home"
        >
          {!isHome && !menuOpen && (
            <span className="nav__logo-home-return" aria-hidden>
              ←
            </span>
          )}
          <img src={LOGO_SRC} alt="" className="nav__logo" width={32} height={32} aria-hidden />
          {!isHome && !menuOpen && (
            <span className="nav__logo-home-label">Home</span>
          )}
        </Link>

        <nav className="nav__desktop" aria-label="Primary navigation">
          <Link
            to="/"
            className={`nav__brand${!isHome ? ' nav__brand--return' : ''}`}
            onClick={closeMenu}
            aria-label="Home"
            title={isHome ? undefined : 'Home'}
          >
            {!isHome && (
              <span className="nav__brand-return" aria-hidden>
                ←
              </span>
            )}
            <img src={LOGO_SRC} alt="" className="nav__logo" width={32} height={32} aria-hidden />
            <span className="nav__brand-copy">
              <span className="nav__brand-text">Vatsal Verma</span>
              <span className="nav__brand-hint">Home</span>
            </span>
          </Link>

          <div className="nav__actions">
            <ul className="nav__list">
              {NAV_ITEMS.map(({ id, label, to }) => {
                const isActive = isPathActive(to);
                return (
                  <li key={id}>
                    <Link
                      to={to}
                      className={`nav__link${isActive ? ' is-active' : ''}`}
                      aria-current={isActive ? 'page' : undefined}
                      onClick={closeMenu}
                    >
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <ThemeToggle
              theme={theme}
              onToggle={toggleTheme}
              className="theme-toggle--desktop"
            />
          </div>
        </nav>

        <div className="nav__mobile-controls">
          <ThemeToggle
            theme={theme}
            onToggle={toggleTheme}
            className="theme-toggle--bar"
          />
          <button
            type="button"
            className="nav__toggle"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="nav-mobile-menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <span className="nav__toggle-bar" aria-hidden />
            <span className="nav__toggle-bar" aria-hidden />
            <span className="nav__toggle-bar" aria-hidden />
          </button>
        </div>
      </div>

      <div
        id="nav-mobile-menu"
        className={`nav__mobile${menuOpen ? ' is-open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <p className="nav__mobile-home">Vatsal Verma</p>
        <ul className="nav__mobile-list">
          {MOBILE_NAV_ITEMS.map(({ id, label, to }) => {
            const isActive = isPathActive(to);
            const cls = `nav__mobile-link${isActive ? ' is-active' : ''}`;
            return (
              <li key={id}>
                <Link
                  to={to}
                  className={cls}
                  onClick={closeMenu}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {label}
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      {menuOpen && (
        <button
          type="button"
          className="nav__backdrop"
          aria-label="Close menu"
          onClick={closeMenu}
        />
      )}
    </div>
  );
};

export default Nav;
